import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Divider } from '@mui/material'
import ProfileSelector from '../molecules/ProfileSelector'
import BusinessCompanyInfoSection from '../molecules/BusinessCompanyInfoSection'
import EmailPurposeTargetingSection from '../molecules/EmailPurposeTargetingSection'

const ProfileAutofillTabContent = ({
  control,
  companyValidationRules,
  profiles,
  selectedProfileIndex,
  isAddingNewProfile,
  onProfileChange,
  onAddProfile,
  onDeleteProfile,
  onCancelAdd,
  onStartAdd,
  onProfileNameChange,
  websiteUrl,
  onWebsiteUrlChange,
  onFetchFromWebsite,
  isFetchingFromWebsite
}) => {
  const { t } = useTranslation()

  return (
    <Box className="p-3" style={{ minHeight: '25rem' }}>
      <ProfileSelector
        profiles={profiles}
        selectedProfileIndex={selectedProfileIndex}
        isAddingNewProfile={isAddingNewProfile}
        onProfileChange={onProfileChange}
        onAddProfile={onAddProfile}
        onDeleteProfile={onDeleteProfile}
        onCancelAdd={onCancelAdd}
        onStartAdd={onStartAdd}
        onProfileNameChange={onProfileNameChange}
        websiteUrl={websiteUrl}
        onWebsiteUrlChange={onWebsiteUrlChange}
        onFetchFromWebsite={onFetchFromWebsite}
        isFetchingFromWebsite={isFetchingFromWebsite}
      />

      <Divider sx={{ mb: 4 }} />

      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        {t('mailTemplate.wizard.ai.businessCompanyInfo')}
      </Typography>
      <BusinessCompanyInfoSection
        control={control}
        fieldPrefix="senderCompany"
        validationRules={companyValidationRules}
      />

      <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4, mb: 3 }}>
        {t('mailTemplate.wizard.ai.emailPurpose')}
      </Typography>
      <EmailPurposeTargetingSection
        control={control}
        fieldPrefix="emailPurpose"
      />
    </Box>
  )
}

export default ProfileAutofillTabContent
